import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Icon } from '@zenlayer/zen-design';
import { Breadcrumb } from '../bread-crumb';
import cls from './index.module.less';
export const Header = ({ onClose, urlHref, routes, labelIndex, addition, customBreads, }) => {
    return (_jsxs("div", { className: cls.header, children: [_jsx("div", { className: cls.breadCrumb, children: _jsx(Breadcrumb, { routes: routes, labelIndex: labelIndex, urlHref: urlHref, copyable: true, addition: addition, customBreads: customBreads }) }), _jsx("div", { style: { marginLeft: '8px' }, children: _jsx(Button, { type: "text", textBaseColor: true, size: "s", icon: _jsx(Icon, { type: "suggest/Close" }), onClick: () => {
                        onClose?.();
                    } }) })] }));
};
